import {
  checkForUpdates,
  emptyAnalysisSection,
  showSuccessAlert,
  updateAnalysisView,
} from "@actions";
import Analysis from "@api/analysis";
import AnalysisFilters from "@components/analysis/AnalysisFilters";
import { handleDownload } from "@helpers/downloads";
import {
  graphInitialState,
  gridInitialState,
} from "@reducers/analysisViewReducer";
import DataGrid from "@shared/DataGrid";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";
import AnalysisButtons from "../analysis/AnalysisButtons";
import AnalysisGraphControls from "../analysis/AnalysisGraphControls";
import AnalysisTabs from "../analysis/AnalysisTab";

class AnalysisView extends React.Component {
  constructor() {
    super();
    this.graphDebounce = _.debounce(this.loadGraph, 850);
  }

  handleRefresh = () => {
    const {
      startDate,
      endDate,
      fromWeek,
      toWeek,
      selectedStartTime,
      selectedEndTime,
      selectedCategory,
      selectedMeasure,
      selectedMeasures,
      selectedTotalBy,
      selectedTimeGroupBy,
      selectedDataGroup,
      selectedDayOfWeek,
      selectedDataSource,
    } = this.props.analysis;
    const { operator, company, subcompany, site } =
      this.props.analysisFilters.filterSelected;

    this.props
      .updateAnalysisView({ loading: true, graph: graphInitialState })
      .then(() => {
        Analysis.getGrid(
          startDate,
          endDate,
          fromWeek,
          toWeek,
          selectedStartTime,
          selectedEndTime,
          selectedMeasure,
          selectedMeasures,
          selectedTotalBy,
          selectedTimeGroupBy,
          selectedDataGroup,
          selectedCategory,
          operator,
          company.id,
          subcompany.id,
          site.id,
          selectedDayOfWeek,
          selectedDataSource,
        ).then(
          (grid) => {
            this.props.updateAnalysisView({
              grid,
              details: gridInitialState,
              graph: graphInitialState,
              loading: false,
              selectedRows: [],
              hideGraph: true,
            });
          },
          () =>
            this.props.updateAnalysisView({
              loading: false,
              grid: gridInitialState,
              details: gridInitialState,
              graph: graphInitialState,
              selectedRows: [],
              hideGraph: true,
            }),
        );
      });
  };

  componentWillUnmount() {
    this.props.emptyAnalysisSection();
  }

  handleExport = () => {
    const {
      startDate,
      endDate,
      fromWeek,
      toWeek,
      selectedStartTime,
      selectedEndTime,
      selectedMeasure,
      selectedMeasures,
      selectedCategory,
      selectedTotalBy,
      selectedTimeGroupBy,
      selectedDataGroup,
      selectedDayOfWeek,
      selectedDataSource,
    } = this.props.analysis;
    const { operator, company, subcompany, site } =
      this.props.analysisFilters.filterSelected;
    const { email } = this.props.login;

    this.props.updateAnalysisView({ downloadLoading: true }).then(() => {
      Analysis.getExport(
        email,
        startDate,
        endDate,
        fromWeek,
        toWeek,
        selectedStartTime,
        selectedEndTime,
        selectedMeasure,
        selectedMeasures,
        selectedTotalBy,
        selectedTimeGroupBy,
        selectedDataGroup,
        selectedCategory,
        operator,
        company.id,
        subcompany.id,
        site.id,
        selectedDayOfWeek,
        selectedDataSource,
      ).then(
        (response) => {
          handleDownload(response);
          this.props.updateAnalysisView({ downloadLoading: false });
        },
        () => this.props.updateAnalysisView({ downloadLoading: false }),
      );
    });
  };

  loadGraph = () => {
    const {
      timeGroupBy,
      startDate,
      endDate,
      fromWeek,
      toWeek,
      selectedStartTime,
      selectedEndTime,
      selectedRows,
      selectedCategory,
      selectedMeasure,
      selectedMeasures,
      selectedTotalBy,
      selectedTimeGroupBy,
      selectedDataGroup,
      selectedDayOfWeek,
      selectedDataSource,
    } = this.props.analysis;
    const { operator, company, subcompany, site } =
      this.props.analysisFilters.filterSelected;
    const { canGraph } =
      timeGroupBy.find((x) => x.id === selectedTimeGroupBy) || false;
    this.props
      .updateAnalysisView({ graph: graphInitialState, graphLoading: true })
      .then(() => {
        if (canGraph && selectedRows.length > 0) {
          Analysis.getGraph(
            selectedRows,
            startDate,
            endDate,
            fromWeek,
            toWeek,
            selectedStartTime,
            selectedEndTime,
            selectedMeasure,
            selectedMeasures,
            selectedTotalBy,
            selectedTimeGroupBy,
            selectedDataGroup,
            selectedCategory,
            operator,
            company.id,
            subcompany.id,
            site.id,
            selectedDayOfWeek,
            selectedDataSource,
          ).then(
            (graph) =>
              this.props.updateAnalysisView({ graph, graphLoading: false }),
            () =>
              this.props.updateAnalysisView({
                graphLoading: false,
                graph: graphInitialState,
              }),
          );
        } else {
          this.props.updateAnalysisView({
            graphLoading: false,
            graph: graphInitialState,
          });
        }
      });
  };

  loadGridByAsset = () => {
    const {
      timeGroupBy,
      startDate,
      endDate,
      fromWeek,
      toWeek,
      selectedStartTime,
      selectedEndTime,
      selectedRows,
      selectedCategory,
      selectedMeasure,
      selectedMeasures,
      selectedTotalBy,
      selectedTimeGroupBy,
      selectedDataGroup,
      selectedDayOfWeek,
      selectedDataSource,
    } = this.props.analysis;
    const { operator, company, subcompany, site } =
      this.props.analysisFilters.filterSelected;
    const { canGraph } =
      timeGroupBy.find((x) => x.id === selectedTimeGroupBy) || false;
    this.props
      .updateAnalysisView({ details: gridInitialState, detailsLoading: true })
      .then(() => {
        if (canGraph && selectedRows.length > 0) {
          Analysis.getGridByAsset(
            selectedRows,
            startDate,
            endDate,
            fromWeek,
            toWeek,
            selectedStartTime,
            selectedEndTime,
            selectedMeasure,
            selectedMeasures,
            selectedTotalBy,
            selectedTimeGroupBy,
            selectedDataGroup,
            selectedCategory,
            operator,
            company.id,
            subcompany.id,
            site.id,
            selectedDayOfWeek,
            selectedDataSource,
          ).then(
            (details) =>
              this.props.updateAnalysisView({ details, detailsLoading: false }),
            () =>
              this.props.updateAnalysisView({
                detailsLoading: false,
                details: gridInitialState,
              }),
          );
        } else {
          this.props.updateAnalysisView({
            graphLoading: false,
            details: gridInitialState,
          });
        }
      });
  };

  onRowClick = (selectedRow) => {
    const { selectedRows, graphType } = this.props.analysis;
    let newSelectedRows = [];

    if (selectedRows.includes(selectedRow)) {
      newSelectedRows = [...selectedRows.filter((row) => row !== selectedRow)];
    } else {
      if (graphType === 1) {
        newSelectedRows = [selectedRow];
      } else {
        if (selectedRows.length < 5) {
          newSelectedRows = [...selectedRows, selectedRow];
        }
      }
    }
    this.props
      .updateAnalysisView({ selectedRows: newSelectedRows })
      .then(() => {
        this.loadGridByAsset();
        graphType === 1 ? this.loadGraph() : this.graphDebounce();
      });
  };

  componentDidUpdate(prevProps) {
    const { operator } = this.props.analysisFilters.filterSelected;
    if (operator !== prevProps.analysisFilters.filterSelected.operator) {
      Analysis.getMetaData(operator).then((response) => {
        const data = {
          ...response,
          selectedTimeGroupBy: response.timeGroupBy[0]
            ? response.timeGroupBy[0].id
            : null,
          selectedTotalBy: response.totalBy[0] ? response.totalBy[0].id : null,
          selectedMeasure: response.dataSource[0].measures[0]
            ? response.dataSource[0].measures[0].id
            : null,
          selectedMeasures: response.defaultMeasures || [],
          selectedDataGroup: response.dataGroups[0]
            ? response.dataGroups[0].id
            : null,
          selectedDayOfWeek: [...response.daysOfWeek.map((x) => x.id)],
          selectedCategory: [...response.categories.map((x) => x.id)],
          selectedStartTime: response.defaultStartTime,
          selectedEndTime: response.defaultEndTime,
          fromWeek: response.defaultStartWeek,
          toWeek: response.defaultEndWeek,
          selectedDataSource: response.dataSource[0]
            ? response.dataSource[0].id
            : null,
        };
        this.props.updateAnalysisView(data);
      });
    }

    if (
      checkForUpdates(prevProps.analysisFilters, this.props.analysisFilters)
    ) {
      this.props.updateAnalysisView({
        graph: graphInitialState,
        grid: gridInitialState,
      });
    }
  }

  render() {
    const { grid, loading, selectedRows, hideGraph, hideFilters } =
      this.props.analysis;

    const tablet = hideFilters ? 16 : 11;
    const computer = hideFilters ? 16 : 12;
    const largeScreen = hideFilters ? 16 : 13;
    const wideScreen = hideFilters ? 16 : 14;

    return (
      <Grid
        className="height-100 gs-flex-container-vertical"
        padded="vertically"
      >
        <Grid.Row>
          <Grid.Column tablet={6} computer={5} largeScreen={4} widescreen={3}>
            <AnalysisButtons onExport={this.handleExport} />
          </Grid.Column>
          <Grid.Column
            tablet={10}
            computer={11}
            largeScreen={12}
            widescreen={13}
            textAlign="right"
          >
            <AnalysisGraphControls />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          {!hideFilters && (
            <Grid.Column tablet={5} computer={4} largeScreen={3} widescreen={2}>
              <AnalysisFilters onRefresh={this.handleRefresh} />
            </Grid.Column>
          )}
          <Grid.Column
            tablet={tablet}
            computer={computer}
            largeScreen={largeScreen}
            widescreen={wideScreen}
            className="gs-flex-container-vertical"
          >
            <DataGrid
              loading={loading}
              headings={grid.headerDef}
              data={grid.data}
              rowDef={grid.rowDef}
              activeRow={selectedRows}
              onRowClick={this.onRowClick}
              fullHeight
              className="mb-1"
            />

            {!hideGraph ? <AnalysisTabs /> : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    analysis: state.analysisView,
    analysisFilters: state.analysisFilters,
    login: state.logIn,
  };
};

export default connect(mapStateToProps, {
  updateAnalysisView,
  showSuccessAlert,
  emptyAnalysisSection,
})(AnalysisView);
